import elev8tionLogo from '../../../assets/images/partners/images/Elev8tion Logo (Black).png';
import gothamLogo from '../../../assets/images/partners/images/Gotham Logo (Black).png';
import hotworxLogo from '../../../assets/images/partners/images/Hotworx.png';
import powerhouseLogo from '../../../assets/images/partners/images/Powerhouse logo.png';
import purepowerLogo from '../../../assets/images/partners/images/Purepower Logo (Pink).png';
import rumbleLogo from '../../../assets/images/partners/images/Rumble logo.png';
import worxLogo from '../../../assets/images/partners/images/worx (1).png';
import airlabLogo from '../../../assets/images/partners/images/airlabfitness_logo.jpg';
import imaYogaLogo from '../../../assets/images/partners/images/gym-logos_ImaYoga_BrandAssets_Pine-Wordmark.png';
import sqlptLogo from '../../../assets/images/partners/images/gym-logos_SQLPT logo.png';
import tonehouseLogo from '../../../assets/images/partners/images/tonehouse logo.png';
import sweat440Logo from '../../../assets/images/partners/images/SWEAT440___LOGOS_Logo.jpg';

import {
  LogoSliderContainer,
  SliderTitle,
  SliderWrapper,
  LogoBand,
  LogoGroup,
  LogoItem,
  LogoImage,
} from './styles';

const logos = [
  { id: 1, name: 'Elev8tion Fitness', imageUrl: elev8tionLogo },
  { id: 2, name: 'Gotham Gym', imageUrl: gothamLogo },
  { id: 3, name: 'HOTWORX', imageUrl: hotworxLogo },
  { id: 4, name: 'Powerhouse Gym', imageUrl: powerhouseLogo },
  { id: 5, name: 'Purepower', imageUrl: purepowerLogo },
  { id: 6, name: 'Rumble Boxing', imageUrl: rumbleLogo },
  { id: 7, name: 'Worx', imageUrl: worxLogo },
  { id: 8, name: 'Air Lab Fitness', imageUrl: airlabLogo },
  { id: 9, name: 'Ima Yoga', imageUrl: imaYogaLogo },
  { id: 10, name: 'SQLPT Pilates', imageUrl: sqlptLogo },
  { id: 11, name: 'Tone House', imageUrl: tonehouseLogo },
  { id: 12, name: 'Sweat440', imageUrl: sweat440Logo, height: 80 },
];

const LogoSlider = () => {
  return (
    <LogoSliderContainer>
      <SliderTitle>Train with 100+ Partners!</SliderTitle>
      <SliderWrapper>
        <LogoBand>
          <LogoGroup>
            {logos.map((logo) => (
              <LogoItem key={logo.id}>
                <LogoImage src={logo.imageUrl} alt={logo.name} style={logo.height ? { height: logo.height } : undefined} />
              </LogoItem>
            ))}
          </LogoGroup>
          <LogoGroup aria-hidden>
            {logos.map((logo) => (
              <LogoItem key={`dup1-${logo.id}`}>
                <LogoImage src={logo.imageUrl} alt={logo.name} style={logo.height ? { height: logo.height } : undefined} />
              </LogoItem>
            ))}
          </LogoGroup>
          <LogoGroup aria-hidden>
            {logos.map((logo) => (
              <LogoItem key={`dup2-${logo.id}`}>
                <LogoImage src={logo.imageUrl} alt={logo.name} style={logo.height ? { height: logo.height } : undefined} />
              </LogoItem>
            ))}
          </LogoGroup>
        </LogoBand>
      </SliderWrapper>
    </LogoSliderContainer>
  );
};

export default LogoSlider;
